import { render, staticRenderFns } from "./VideoCallReceive.vue?vue&type=template&id=65c15f04&scoped=true&"
import script from "./VideoCallReceive.vue?vue&type=script&lang=ts&"
export * from "./VideoCallReceive.vue?vue&type=script&lang=ts&"
import style0 from "./VideoCallReceive.vue?vue&type=style&index=0&id=65c15f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c15f04",
  null
  
)

export default component.exports